import React, { useState } from "react";

function Pagination({ totalPages, currentPage, onPageChange }) {
    const current = parseInt(currentPage);
    const isFirstPage = current === 1;
    const isLastPage = current === totalPages || totalPages === 0;

    const handlePageClick = (page) => {
        if (page !== current && page !== "...") {
            onPageChange(page);
        }
    };

    const generatePageNumbers = () => {
        const delta = 2;
        const range = [];
        const rangeWithDots = [];
        let lastPageShown;

        for (let i = 1; i <= totalPages; i++) {
            if (
                i === 1 ||
                i === totalPages ||
                (i >= current - delta && i <= current + delta)
            ) {
                range.push(i);
            }
        }

        for (let i of range) {
            if (lastPageShown) {
                if (i - lastPageShown === 2) {
                    rangeWithDots.push(lastPageShown + 1);
                } else if (i - lastPageShown > 2) {
                    rangeWithDots.push("...");
                }
            }
            rangeWithDots.push(i);
            lastPageShown = i;
        }

        return rangeWithDots;
    };

    return (
        <div className="flex items-center justify-center space-x-1 sm:space-x-2">
            {/* Претходна */}
            <button
                onClick={() => handlePageClick(current - 1)}
                disabled={isFirstPage}
                className={`btn btn-sm ${isFirstPage ? "btn-disabled" : "btn-primary"}`}
            >
                Претходна
            </button>

            {/* Страници: целосно видливи само на sm (или поголеми) екрани */}
            <div className="hidden sm:flex space-x-1">
                {generatePageNumbers().map((page, index) => (
                    <React.Fragment key={index}>
                        {page === "..." ? (
                            <span className="btn btn-sm btn-disabled">...</span>
                        ) : (
                            <button
                                onClick={() => handlePageClick(page)}
                                className={`btn btn-sm ${current === page ? "btn-bold btn-disabled" : "btn-outline"
                                    }`}
                            >
                                {page}
                            </button>
                        )}
                    </React.Fragment>
                ))}
            </div>

            {/* Тековна страница: само на мали екрани */}
            <span className="sm:hidden px-2 text-sm">
                Страна {current} од {totalPages}
            </span>

            {/* Следна */}
            <button
                onClick={() => handlePageClick(current + 1)}
                disabled={isLastPage}
                className={`btn btn-sm ${isLastPage ? "btn-disabled" : "btn-primary"}`}
            >
                Следна
            </button>
        </div>
    );
}

export default Pagination
